// src/Dashboard.js
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "./Header";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userName = searchParams.get("user");

  
  return (
    <div>
      <div className="container mt-5">
        <h2>Welcome, {userName}!</h2>
        <p>You've successfully registered.</p>
      </div>
    </div>
  );
};

export default Dashboard;
